import { Directive } from '@angular/core';

@Directive({
  selector: '[xpo-form-inline], [xpoFormInline]',
  host: { class: 'xpo-Form--inline' },
})
export class XpoFormFieldInline {}
